module.exports = __webpack_public_path__ + "static/media/DEAC_Logo_labdarugas.6895c4b6.png";